import { render } from "./FileSync.vue?vue&type=template&id=fdca6470&scoped=true"
import script from "./FileSync.vue?vue&type=script&lang=js"
export * from "./FileSync.vue?vue&type=script&lang=js"

import "./FileSync.vue?vue&type=style&index=0&id=fdca6470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdca6470"]])

export default __exports__